module.exports = ($scope, $state, Api, adverseTerm, languages, user, adverseTermsLists) ->
  handleSave = () ->
    $scope.saving = false
    $state.go('adverse-terms')

  $scope.save = (adverseTermForm) ->
    adverseTermForm.$submitted = true
    if !adverseTermForm.$valid or !$scope.adverseTerm.language
      return
    $scope.saving = true
    if $scope.adverseTerm.id
      $scope.adverseTerm.$update().then handleSave
    else
      $scope.adverseTerm.$save().then handleSave

  $scope.delete = () ->
    if confirm('Are you sure you want to delete this Adverse Terms list')
      $scope.adverseTerm.$delete().then ->
        $state.go('adverse-terms')

  $scope.canEdit = () ->
    if $scope.adverseTerm.owner
      return $scope.adverseTerm.owner == user.id
    else
      return true

  $scope.adverseTerm = adverseTerm or new Api.AdverseTerms
  $scope.languages = languages
  $scope.adverseTermsLists = adverseTermsLists
